/* eslint-disable prettier/prettier */
import React from 'react'
import { Container } from '../styles/AbstractLayout'

const Abstract = () => (
  <Container>
    <div>
      <ul>
        <li>🕒 1180h carga horaria total</li>
        <li>✅ Suporte e Tutoria</li>
        <li>📜 26 Certificações</li>
        <li>📓 03 Qualificações Profissionais</li>
        <li>🎖️ 02 Certificados(s)</li>
        <li>☀️ Seguro Acadêmico</li>
        <li>📃 Certificado com Validade Nacional</li>
      </ul>
     </div>
    </Container>
)

export default Abstract